import { HiOutlineHome } from "react-icons/hi2";
import { ErrorImage } from "../../pages/LogInPage/EmailVerficationPromptConfig";
import AuthButton from "../../pages/LogInPage/LoginButton";
import { useNavigate } from "react-router-dom";
import OnboardingBackground from "./OnboardingBackground";
import logoNew from "../../assets/Images/VerticalDarkLogo1.svg";
import sat from "../../assets/Images/SATprep1.svg";

const LinkExpired = ({ redirectTo }: { redirectTo?: string }) => {
  const navigate = useNavigate();
  const handleReturntoHome = () => {
    if (redirectTo) {
      navigate(redirectTo);
    } else {
      navigate("/login");
    }
  };
  return (
    <OnboardingBackground>
      <div className="flex flex-col justify-center items-center px-10 w-fit bg-satPrepTransWhite p-9 my-9 rounded-[28px]">
        <div className="flex flex-col items-center w-[720px]  justify-center font-gully">
          <div className="flex flex-col justify-center items-center px-10">
            <img src={logoNew} className="w-[260px] h-[163px]" alt="FullMarks Logo" />
            <img src={sat} className="w-[211px] h-[68px]"  alt="SATprep Logo" />
            <h1 className='font-gully text-[40px] font-bold text-satPrepAccent my-9'>
              Seems like you got lost...
            </h1>
            <div>
              <ErrorImage />{" "}
            </div>
            <AuthButton
              text="Return To Home"
              icon={<HiOutlineHome size={24} />}
              iconPosition="left"
              onClick={handleReturntoHome}
              loader={false}
              disabled={false}
            />
          </div>
        </div>
      </div>
    </OnboardingBackground>
    
  );
};

export default LinkExpired;
